export default __webpack_public_path__ + "static/media/announcement_tab_icon_white.f5cda2b0.svg";